/**
 * Main JavaScript file for VRBTM application
 * Refactored to use modular imports
 */

import { initializeMobileDetection } from './modules/mobile-detection.js';
import { initializeBootstrapComponents, initializeEnhancedTooltips } from './modules/bootstrap-components.js';
import { initializeSidebar } from './modules/sidebar-management.js';
import {
  initializeFormHandlers,
  initializeAutoSave,
  initializeCharacterCount,
  initializeUploadProgress,
} from './modules/form-handlers.js';
import {
  initializeTableFeatures,
  initializeTableSorting,
  initializeFileSorting,
  initializeBatchOperations,
} from './modules/table-functionality.js';
import { initializeKeyboardNavigation } from './modules/keyboard-navigation.js';
import { initializeUIEnhancements, initializeTheme } from './modules/ui-enhancements.js';
import { initializeSessionManagement } from './modules/session-management.js';
import { initializeTranscriptionHandlers } from './modules/transcription-handlers.js';
import { initializeReaderModeBanner } from './modules/reader-mode-banner.js';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize all modules
  initializeMobileDetection();
  initializeBootstrapComponents();
  initializeSidebar();
  initializeFormHandlers();
  initializeTableFeatures();
  initializeKeyboardNavigation();
  initializeUIEnhancements();
  initializeSessionManagement();
  initializeTranscriptionHandlers();
  initializeReaderModeBanner();
  initializeAutoSave();
  initializeCharacterCount();
  initializeUploadProgress();
  initializeEnhancedTooltips();
  initializeTableSorting();
  initializeFileSorting();
  initializeBatchOperations();
  initializeTheme();
});
